import { render, staticRenderFns } from "./center1.vue?vue&type=template&id=527874ec"
import script from "./center1.vue?vue&type=script&lang=js"
export * from "./center1.vue?vue&type=script&lang=js"
import style0 from "./center1.vue?vue&type=style&index=0&id=527874ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports